<template>
	<div class="py-4 container-fluid">
		<div class="row">
			<div
				style="
					border: 5px dashed grey;
					box-sizing: border-box;
					justify-content: center;
					align-items: center;
					font-size: 20px;
				"
				class="p-3 m-3"
			>
				[[DEV]] DASHBOARD Tipo Utnte (ID: {{ roleId }})
				<br />
				Utente:
				<div
					style="
						max-height: 150px;
						overflow-y: auto;
						padding: 10px;
						background-color: #f9f9f9;
						border: 1px solid #ccc;
						font-family: 'Courier New', monospace;
						white-space: pre-wrap;
					"
				>
					{{ this.$store.state.user }}
				</div>
				<button @click="testMethod" role="link">Posts</button>
			</div>
			<div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
				<mini-statistics-card
					title="Bentornato"
					:value="userName[0].toUpperCase() + userName.slice(1)"
					:percentage="{
						value: '+505%',
						color: 'text-success',
					}"
					:icon="{
						component: 'ni ni-money-coins',
						background: iconBackground,
					}"
					direction-reverse
				/>
			</div>
			<div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
				<mini-statistics-card
					title="Tipo Utente (ID)"
					:value="roleId"
					:percentage="{
						value: '+3%',
						color: 'text-success',
					}"
					:icon="{
						component: ' ni ni-world',
						background: iconBackground,
					}"
					direction-reverse
				/>
			</div>
			<div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
				<mini-statistics-card
					title="da def..."
					value="+3,462"
					:percentage="{
						value: '-2%',
						color: 'text-danger',
					}"
					:icon="{
						component: 'ni ni-paper-diploma',
						background: iconBackground,
					}"
					direction-reverse
				/>
			</div>
			<div class="col-xl-3 col-sm-6 mb-xl-0">
				<mini-statistics-card
					title="da def..."
					value="$103,430"
					:percentage="{
						value: '+5%',
						color: 'text-success',
					}"
					:icon="{
						component: 'ni ni-cart',
						background: iconBackground,
					}"
					direction-reverse
				/>
			</div>
		</div>
	</div>
</template>
<script>
	import MiniStatisticsCard from '@/examples/Cards/MiniStatisticsCard.vue';
	import US from '../assets/img/icons/flags/US.png';
	import DE from '../assets/img/icons/flags/DE.png';
	import GB from '../assets/img/icons/flags/GB.png';
	import BR from '../assets/img/icons/flags/BR.png';
	import {
		faHandPointer,
		faUsers,
		faCreditCard,
		faScrewdriverWrench,
	} from '@fortawesome/free-solid-svg-icons';

	export default {
		name: 'dashboard-default',
		data() {
			return {
				iconBackground: 'bg-gradient-success',
				faCreditCard,
				faScrewdriverWrench,
				faUsers,
				faHandPointer,
				sales: {
					us: {
						country: 'United States',
						sales: 2500,
						value: '$230,900',
						bounce: '29.9%',
						flag: US,
					},
					germany: {
						country: 'Germany',
						sales: '3.900',
						value: '$440,000',
						bounce: '40.22%',
						flag: DE,
					},
					britain: {
						country: 'Great Britain',
						sales: '1.400',
						value: '$190,700',
						bounce: '23.44%',
						flag: GB,
					},
					brasil: {
						country: 'Brasil',
						sales: '562',
						value: '$143,960',
						bounce: '32.14%',
						flag: BR,
					},
				},
			};
		},
		components: {
			MiniStatisticsCard,
		},
		computed: {
			userName() {
				return this.$store.state.user.first_name ?? '---';
			},
			roleId() {
				return this.$store.state.user.role_id ?? '---';
			},
		},
		methods: {
			async testMethod() {},
		},
		mounted() {},
	};
</script>
